import React, { useReducer, useEffect } from 'react';
import AppContext from './appContext';
import AppReducer from './appReducer';

import config from '../../config.js';

import {
    SET_LOADING,
    SET_DATA,
    FILTER_DATA,
    SET_CURRENT_PAGE,
    SET_SORT,
    SET_MAP_VIEW,
    TOGGLE_FILTER,
    TOGGLE_OPTION,
    UNSET_OPTIONS,
    SET_RANGE,
    RESET_RANGE
} from '../types';

const returnYYYYMMDD = (numFromToday = 0) => {
    let d = new Date();
    d.setDate(d.getDate() + numFromToday);
    const month = d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
    const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
    return `${d.getFullYear()}${month}${day}`;
  };

const AppState = props => {

    let localState = false; // JSON.parse(localStorage.getItem("ace_explore"));
    const localStorageState = localStorage.getItem("ace_explore");
    if ( localStorageState != null ) {
        localState = JSON.parse(localStorageState)
    }

    const initialState = {
        loaded: false,
        loadedDate: false,
        filterFromUrlSet: false,
        currentPage: 1,
        sort: 'releasedate',
        data: [],
        dataFiltered: [],
        dictionaries: [],
        availableDictionaries: [],
        showMap: false,
        activeFilters: [],
        activeOptions: {},
        dateRange: { min: 0, max: 1 },
        dataRangeMin: 0,
        dataRangeMax: 0
    }

    const [state, dispatch] = useReducer(AppReducer, localState || initialState);

    useEffect(() => {
        localStorage.setItem("ace_explore", JSON.stringify(state));
    }, [state]);


    const getData = async () => {

        const todaysDate = parseInt(returnYYYYMMDD())
        const loadedAndStale = state.loaded && parseInt(todaysDate) != parseInt(state.loadedDate)

        if ( loadedAndStale || !state.loaded ) {
            setLoading();
            const res = await fetch(`${config.jsonsUrl}/ace-explore.json?v=${Date.now()}`);
            const data = await res.json();

            dispatch({
                type: SET_DATA,
                payload: {data: data, loadedDate: todaysDate}
            });
        }

    };

    // toggle filter
    const toggleActiveFilter = (ident) => {
        dispatch({ type: TOGGLE_FILTER, payload: ident });
    };

    // toggle filter option
    const toggleSelectedOption = (idents) => {
        dispatch({ type: TOGGLE_OPTION, payload: idents });
        dispatch({ type: FILTER_DATA });
    }

    // unset filter options
    const unsetSelectedOptions = (ident) => {
        dispatch({ type: UNSET_OPTIONS, payload: ident });
        dispatch({ type: FILTER_DATA });
    }

    // set time range
    const setDateRange = (range) => {
        dispatch({ type: SET_RANGE, payload: range });
        dispatch({ type: FILTER_DATA });
    }

    // reset time range
    const resetDateRange = () => {
        dispatch({ type: RESET_RANGE });
        dispatch({ type: FILTER_DATA });
    }



    // set loading
    const setLoading = () => dispatch({ type: SET_LOADING });

    // set page / pagination
    const setPage = (page) => dispatch({ type: SET_CURRENT_PAGE, payload: page });

    // set sorting
    const setSort = (sort) => dispatch({ type: SET_SORT, payload: sort });

    // set map
    const setMapView = (show) => dispatch({ type: SET_MAP_VIEW, payload: show });

    return <AppContext.Provider
        value={{
            loaded: state.loaded,
            getData: getData,
            data: state.data,
            dataFiltered: state.dataFiltered,
            currentPage: state.currentPage,
            setPage: setPage,
            sort: state.sort,
            setSort: setSort,
            showMap: state.showMap,
            setMapView: setMapView,
            dictionaries: state.dictionaries,
            availableDictionaries: state.availableDictionaries,
            toggleActiveFilter: toggleActiveFilter,
            activeFilters: state.activeFilters,
            toggleSelectedOption: toggleSelectedOption,
            unsetSelectedOptions: unsetSelectedOptions,
            activeOptions: state.activeOptions,
            setDateRange: setDateRange,
            resetDateRange: resetDateRange,
            dateRange: state.dateRange,
            dataRangeMin: state.dataRangeMin,
            dataRangeMax: state.dataRangeMax,
            filterFromUrlSet: state.filterFromUrlSet
        }}>
        {props.children}
    </AppContext.Provider>
};

export default AppState;